import { DevelopmentLogger } from './DevelopmentLogger';
import { GoogleAnalyticsLogger } from './GoogleAnalyticsLogger';
import { BiAnalyticsLogger } from './BiAnalyticsLogger';
import { LOGGER_TYPES } from './loggerTypes';
import { FedopsLogger } from './FedopsLogger';

export const MODES = {
  PRODUCTION: 'PRODUCTION',
  DEVELOPMENT: 'DEVELOPMENT',
};

export class LoggerFactory {
  static CachedLoggers = { developmentLoggers: {} };
  static mode =
    process.env.NODE_ENV === 'production'
      ? MODES.PRODUCTION
      : MODES.DEVELOPMENT;
  static isLocalViewer;
  static artifactId;
  constructor(isLocalViewer, isBranch, artifactId) {
    LoggerFactory.isLocalViewer = isLocalViewer;
    LoggerFactory.isBranch = isBranch;
    LoggerFactory.artifactId = artifactId;
    return this;
  }

  static productionMode() {
    LoggerFactory.mode = MODES.PRODUCTION;
  }

  static reset() {
    LoggerFactory.mode = MODES.DEVELOPMENT;
  }

  getMode() {
    return LoggerFactory.mode;
  }

  isProductionMode() {
    return this.getMode() === MODES.PRODUCTION;
  }

  getLogger(type) {
    if (!LOGGER_TYPES[type]) {
      throw new TypeError(`There is no logger of type ${type}`);
    }

    return this.produceLogger(type);
  }

  produceLogger = (type) => {
    const loggers = {
      [LOGGER_TYPES.ANALYTICS_GOOGLE]: () =>
        new GoogleAnalyticsLogger(
          LoggerFactory.isLocalViewer,
          LoggerFactory.isBranch,
        ),
      [LOGGER_TYPES.ANALYTICS_BI]: () =>
        new BiAnalyticsLogger(
          LoggerFactory.isLocalViewer,
          LoggerFactory.isBranch,
          LoggerFactory.artifactId,
        ),
      DEVELOPMENT: () =>
        new DevelopmentLogger(
          type,
          LoggerFactory.isLocalViewer,
          LoggerFactory.isBranch,
        ),
      FEDOPS: () => new FedopsLogger(LoggerFactory.artifactId),
    };
    if (this.isProductionMode()) {
      if (!LoggerFactory.CachedLoggers[type]) {
        LoggerFactory.CachedLoggers[type] = loggers[type]();
      }
      return LoggerFactory.CachedLoggers[type];
    }

    if (!LoggerFactory.CachedLoggers.developmentLoggers[type]) {
      LoggerFactory.CachedLoggers.developmentLoggers[type] =
        type !== LOGGER_TYPES.FEDOPS ? loggers.DEVELOPMENT() : loggers.FEDOPS();
    }
    return LoggerFactory.CachedLoggers.developmentLoggers[type];
  };
}
